module.exports = __webpack_public_path__ + "static/media/0049_Medium.02365b6a.jpg";